export default __webpack_public_path__ + "static/media/couche-doublure.43c795cc.jpg";